import script from "./sms-texts-configuration-templates.vue?vue&type=script&setup=true&lang=ts"
export * from "./sms-texts-configuration-templates.vue?vue&type=script&setup=true&lang=ts"

import "./sms-texts-configuration-templates.vue?vue&type=style&index=0&id=4c1c27b9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c1c27b9"]])

export default __exports__